import { FAQSchema, FAQItem } from './FAQSchema';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

interface FAQSectionProps {
  title?: string;
  faqs: FAQItem[];
  className?: string;
}

export function FAQSection({ title = "Frequently Asked Questions", faqs, className }: FAQSectionProps) {
  return (
    <section className={className} itemScope itemType="https://schema.org/FAQPage">
      <FAQSchema faqs={faqs} />
      <h2 className="font-display text-2xl font-semibold mb-6">{title}</h2>
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq, index) => (
          <AccordionItem 
            key={index} 
            value={`faq-${index}`}
            itemScope 
            itemProp="mainEntity" 
            itemType="https://schema.org/Question"
          >
            <AccordionTrigger 
              className="text-left font-medium"
              itemProp="name"
            >
              {faq.question}
            </AccordionTrigger>
            <AccordionContent 
              itemScope 
              itemProp="acceptedAnswer" 
              itemType="https://schema.org/Answer"
            >
              <div itemProp="text" className="text-muted-foreground">
                {faq.answer}
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
